"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _elementUi = require("element-ui");
var _vuex = require("vuex");
var _auth = require("@/utils/auth");
/* import $ from 'jquery'*/
var _default = exports.default = {
  methods: (0, _objectSpread2.default)({}, (0, _vuex.mapMutations)('datamapStore', ['addDataMap'])),
  mounted: function mounted() {
    var _this = this;
    // 当前路由页面触发数据字典加载，其子组件负责收集

    var getDataMapFun = function getDataMapFun() {
      var undisposeedCodes = _this.$store.state.datamapStore.undotypecodes;
      if (undisposeedCodes && undisposeedCodes.length > 0) {
        var loading = _elementUi.Loading.service({
          target: _this.$el
        });
        var thiz = _this;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', process.env.VUE_APP_BASE_API + '/system/dict/data/getDict?dictTypes=' + undisposeedCodes.join(','), false);
        xhr.setRequestHeader('Authorization', 'Bearer ' + (0, _auth.getToken)());
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onreadystatechange = function () {
          // readyState == 4说明请求已完成
          if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
            // 从服务器获得数据
            if (xhr.responseText) {
              var result = JSON.parse(xhr.responseText);
              var data = {};
              result.data.forEach(function (item) {
                // console.log(item);
                if (item[0]) data[item[0].dictType] = {};
                item.forEach(function (child) {
                  data[item[0].dictType][child.dictValue] = child.dictLabel;
                });
              });
              thiz.addDataMap(data);
            }
          }
        };
        xhr.send();
        loading.close();
      }
    };
    if (this.$parent && this.$parent.$options.name == 'ElDialog') {
      if (this.$parent.$children[this.$parent.$children.length - 1] == this) {
        // console.log("---------", this.$options.name);
        getDataMapFun();
      }
    }
    if (this.$route && this.$route.matched.length > 0 && this.$route.matched[this.$route.matched.length - 1].components.default.name == this.$options.name) {
      getDataMapFun();
    }
    if (this.$options && this.$options.name == 'IceSelect') {
      if (this.$props && this.$props.mapTypeCode) {
        this.$nextTick(function () {
          getDataMapFun();
        });
      }
    }
  }
};